<template>
  <div>
    <!--登入成功-->
    <div v-if="$store.getters.noticeMessage" class="popup-wrap" :class="{ active: $store.getters.noticeMessage }">
      <div class="popup-box">
        <div class="popup-success">
          <!-- eslint-disable-next-line -->
          <h5 v-if="isHtml" v-html="message" />
          <!-- Render message as text if it does not contain HTML tags -->
          <h5 v-else>
            {{ message }}
          </h5>
          <button v-if="$store.getters.noticeMessage && $store.getters.noticeMessage.close !=='callAPI'" class="button-style-5" @click="submit">
            <span>{{ submitLabel }}</span>
          </button>
          <button v-if="$store.getters.noticeMessage && $store.getters.noticeMessage.close ==='callAPI'" class="button-style-5" @click="submit">
            <span>YES</span>
          </button>
          <button v-if="$store.getters.noticeMessage && $store.getters.noticeMessage.close ==='callAPI'" class="button-style-5" @click="hideModal">
            <span>NO</span>
          </button>
        </div>
        <a v-if="$store.getters.noticeMessage.message !== $t('Bao.credit_card_notice1')" class="popup-close" @click="hideModal" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Notice',
  data() {
    return {
      isHtml: false
    }
  },
  computed: {
    message() {
      if (!this.$store.getters.noticeMessage) {
        return null
      }

      return this.$te(this.$store.getters.noticeMessage.message) ? this.$t(this.$store.getters.noticeMessage.message) : this.$store.getters.noticeMessage.message
    },
    submitLabel() {
      const isUseOKText = this.$store.getters.noticeMessage.isUseOKText
      if (isUseOKText) {
        return isUseOKText
      } else {
        return this.$te('Bao.submit') ? this.$t('Bao.submit') : 'OK'
      }
    },
    titleLabel() {
      return this.$te('Bao.notice') ? this.$t('Bao.notice') : 'Notice'
    }
  },
  watch: {
    message(newVal, oldVal) {
      if (newVal === 'closeModal') {
        this.hideModal()
      } else if (newVal != null) {
        if (this.message.indexOf('<') > -1) {
          this.isHtml = true
        } else {
          this.isHtml = false
        }
      }
    }
  },
  mounted() {

  },
  methods: {
    hideModal() {
      const pathSegments = window.location.pathname.split('/').filter(segment => segment !== '')
      const firstSegment = pathSegments[0]

      this.$store.commit('SET_NOTICE_MESSAGE', null)
      if (firstSegment === 'campaign') {
        this.$router.push('/').then(() => {
          window.location.reload()
        })
      }
    },
    submit() {
      const func = this.$store.getters.noticeMessage.func
      const close = this.$store.getters.noticeMessage.close
      const msg = this.$store.getters.noticeMessage.message
      if (msg === this.$t('Bao.free_spin_double_check') && close) {
        this.$store.commit('SET_CONFIRM_PURCHASE', true)
      }

      if (close) {
        this.hideModal()
        if (close === 'callAPI') {
          this.$store.commit('SET_API_EXECUTE', true)
        }
      }
      if (func !== undefined && typeof func === 'function') {
        func()
      }
    }
  }
}
</script>
